module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_pot-c466aa3408c8e67e18f4bed4956a92a9.png";